<template>
  <BaseDialogCard
    :dialog-model="dialog"
    :on-cancel-button-pressed="onCancelButtonPressed"
    title="Sensor Issues Details"
  >
    <template #icon>
      <v-icon
        class="mr-1"
        color="var(--color-text)"
      >
        mdi-leak-off
      </v-icon>
    </template>

    <template #activatorButton="{ on: buttonOn, attrs: buttonAttrs }">
      <div
        v-bind="buttonAttrs"
        class="activator-button"
        @click="onActivatorButtonPressed"
        v-on="buttonOn"
      >
        <LoadingDataRow
          icon="mdi-leak-off"
          category="Sensor issues"
          :is-loading="fetchLoading"
          :value="sensorIssues.length.toString()"
        />
      </div>
    </template>

    <template #content>
      <SensorIssuesView />
    </template>
  </BaseDialogCard>
</template>

<script>
import { mapState } from "vuex";
import BaseDialogCard from "@/views/weather_routing/components/BaseDialogCard.vue";
import SensorIssuesView from "@/views/sensor_issues/View.vue";
import LoadingDataRow from "@/views/vessel_information/components/LoadingDataRow.vue";
export default {
  name: "SensorIssuesDialog",
  components: {
    BaseDialogCard,
    SensorIssuesView,
    LoadingDataRow,
  },
  props: {
    dialogModel: Boolean,
  },
  data: function () {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapState(["currentLeg"]),
    ...mapState("sensorIssues", ["sensorIssues", "fetchLoading"]),
  },
  methods: {
    onActivatorButtonPressed() {
      this.dialog = true;
    },
    onCancelButtonPressed() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.activator-button {
  border-radius: 10px;
  transition: all 0.3s ease;
}

.activator-button:hover {
  border: 1px solid var(--color-primary);
  background-color: var(--color-background-secondary);
  border-radius: 10px;
  padding: 5px;
  width: fit-content;
}
</style>
